import { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import hooks from '@g4/automation-hooks';

class PlainButton extends Component {
  static propTypes = {
    htmlType: PropTypes.oneOf(['submit', 'reset', 'button']),
    children: PropTypes.node.isRequired,
    className: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    ariaControls: PropTypes.string,
    onClick: PropTypes.func,
    automationHook: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.shape({
      src: PropTypes.string.isRequired,
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
    }),
    alignIcon: PropTypes.oneOf(['left', 'right', 'outside']),
    iconFlip: PropTypes.bool,
  };

  static defaultProps = {
    htmlType: 'button',
    type: 'primary',
    onClick: Function.prototype,
    alignIcon: 'left',
    iconFlip: false,
  };

  render() {
    const {
      children,
      className,
      htmlType,
      onClick,
      ariaControls,
      automationHook,
      disabled,
    } = this.props;

    return (
      <button
        className={className}
        type={htmlType}
        aria-controls={ariaControls}
        onClick={onClick}
        disabled={disabled}
        {...hooks.hook(automationHook)}
      >
        {children}
      </button>
    );
  }
}

const StyledPlainButton = styled(PlainButton)`
  display: flex;
  align-items: center;
  position: relative;

  ${props =>
    props.icon &&
    css`
      min-height: ${props.icon.height}px;
    `}


    ${props =>
      props.icon &&
      css`
        &::before,
        &::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
          height: ${props.icon.height}px;
          width: ${props.icon.width}px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;

          ${props.iconFlip &&
            css`
              /* flip arrow */
              transform: rotate(180deg);
            `}
        }
      `}
    ${props =>
      props.icon &&
      props.alignIcon === 'left' &&
      css`
      padding-left: ${props.icon.width}px;

      &::before {
        left: 0;
        background-image: url('${props.icon.src}');
      }

    `}

    ${props =>
      props.icon &&
      props.alignIcon === 'right' &&
      css`
      padding-right: ${props.icon.width}px;

      &::after {
        right: 0;
        background-image: url('${props.icon.src}');
      }
    `}
    ${props => {
      switch (props.type) {
        case 'secondary':
          return css`
            color: ${props => props.theme.colors.plainButton.secondary};
          `;
        case 'tertiary':
          return css`
            color: ${props => props.theme.colors.plainButton.tertiary};
          `;

        case 'primary':
        default:
          return css`
            color: #fff;
          `;
      }
    }}
    ${props =>
      props.underlined &&
      css`
        text-decoration: underline;
      `};

  ${props =>
    props.upperCase &&
    css`
      text-transform: uppercase;
    `};
`;

export default StyledPlainButton;
